<template>
    <div>
        <swb-query-sort-area name="swb-query-sort-area" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row" v-if="userInfo != null && userInfo.comLevel == 1">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="complaintSend()">发起投诉</button>
            </div>
        </div>
        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': value == checkStateValue}" class="head-item" v-for="(text, value) in complaintStateList" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="complaintList" border style="width: 100%" >
                <el-table-column align="left" prop="dstMerchantName" label="被投诉方" width="180"></el-table-column>
                <el-table-column align="left" prop="content" label="问题描述"></el-table-column>
                <el-table-column prop="createTime" label="投诉时间" width="260"></el-table-column>
                <el-table-column label="状态" width="180" align="center">
                    <template slot-scope="rows">
                        <span v-if="rows.row.mode == 0 && !rows.row.closed">协商中</span>
                        <span v-if="rows.row.mode == 1 && !rows.row.closed">协调中</span>
                        <span v-if="rows.row.closed">已关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="toComplaintInfo(rows.row.id)">查看详情</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import userApi from '../../api/user'
    import custsvcApi from '../../api/custsvc'

    import SwbComplaintInfo from './ComplaintInfo';
    Routes.add(SwbComplaintInfo);
    import SwbComplaintSave from './ComplaintSave';
    Routes.add(SwbComplaintSave);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "被投诉方名称",
                "code": "dstMerchantName",
                "basic": true
            },
            {
                "type": "Date2",
                "label": "投诉时间",
                "code": "createTime",
                "basic": true,
                "valueType": "String"
            },
        ],
        "sortFields": [
            {
                "order": "desc",
                "code": "createTime",
                "label": "投诉时间"
            },
        ]
    };

    export default {
        name: 'swb-complaint-send-list',
        path: '/complaint/sent/list',
        pathOld: '/complaint/send/list',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '发起的投诉列表',
        helpArticleCode: 'servicer-complaint-sent-list',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                complaintList: [],
                complaintStateList: [],
                checkStateValue: 0,
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                userInfo: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //----------------------搜索排序----------------------------
            this.queryConfig = searchConfigData || {};
            //
            this.getComplaintList(0);   // 0： 默认选中 全部投诉
            //
            this.complaintStateList = getEnumMap("complaintState", "value2text");
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('.table-layout'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log("domHeight： " + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('[name="swb-query-sort-area"], .simple-row, .tab-container, .pagination-layout'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result) {
                    if(result.type == 'info') {
                        self.userInfo = result.data.scopeEntity;
                    }
                });
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                // console.log(queryModel);
                this.pageNumber = 1;
                //缓存查询条件
                this.getComplaintList(this.checkStateValue);
            },
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getComplaintList(val);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getComplaintList(this.checkStateValue);
            },
            getComplaintList: function (value) {
                let self = this;
                // tabs页的切换
                self.checkStateValue = value;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.complaintState = value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                custsvcApi.getSentComplaintList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.complaintList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toComplaintInfo: function (complaintId) {
                let self = this;
                self.$router.push({
                    path: SwbComplaintInfo.path,
                    query: {
                        complaintId: complaintId
                    }
                });
            },
            // 发起投诉
            complaintSend: function () {
                let self = this;
                self.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        isNotVoucher: true
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/custsvc/ComplaintSendList.vue